import React, { useState } from 'react'
import Classes from './Faq.module.css'
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function Faq() {
    const [expanded, setExpanded] = useState('panel1');
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            question: "What is LuxayWear?",
            answer: "LuxayWear is a UAE-based sneaker store that specializes in premium first-copy shoes imported from verified manufacturers in Vietnam. We focus on delivering high-quality replicas of top global brands, with each pair passing through a detailed quality check to ensure top-tier comfort, style, and durability—shipped fast across the UAE."
        },
        {
            question: "Where are your shoes sourced from?",
            answer: "All products are imported from trusted manufacturers in Vietnam with a track record of consistency."
        },
        {
            question: "How long does delivery take within the UAE?",
            answer: "Delivery usually takes 1–3 working days depending on your location."
        },
        {
            question: "Do you offer any discounts on bulk purchases?",
            answer: "Yes, we offer special discounts on bulk purchases—buy 3 pairs and get 10% off, 5 pairs for 15% off, and 10 pairs or more for 20% off; the discount is automatically applied at checkout, making it perfect for group orders or sneaker lovers building their collection."
        },
        {
            question: "Is cash on delivery (COD) available in the UAE?",
            answer: (
                <>
                    Yes, we offer COD and multiple other payment options across the UAE.
                </>
            )
        },
        {
            question: "How can I contact LuxayWear for questions or support?",
            answer: (
                <>
                    You can reach us anytime via WhatsApp, Instagram DM, or our website’s contact form—our support team is always ready to help with orders, sizing, shipping, or general inquiries.
                </>
            )
        }
    ];

    return (
        <>
            <section id='faq' className={Classes.section}>
                <div>
                    <div className={Classes.miniText} > FAQS </div>
                    <h1 className={Classes.subheading}> Frequently Asked <br /> Questions </h1>
                    <p className={Classes.text} >
                        Explore answers to our most frequently asked <br className={Classes.br1} /> questions about luxaywear <br className={Classes.br2} /> and our approaches. Need more help? <span style={{ color: '#006B32', fontWeight: '600', cursor: 'pointer' }} >Contact us</span>.
                    </p>
                </div>

                <div id='questions' className={Classes.faqs}>
                    <div className={Classes.faqsCon}>
                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === `panel${index + 1}`}
                                onChange={handleChange(`panel${index + 1}`)}
                                sx={{
                                    border: '1px solid #80808024',
                                    boxShadow: 'rgb(0 0 0 / 13%) 0px 1px 2px',
                                    marginBottom: '1rem',
                                    borderRadius: '7px !important',
                                    padding: '6px 20px !important',
                                    '&:before': {
                                        display: 'none',
                                    }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index + 1}bh-content`}
                                    id={`panel${index + 1}bh-header`}
                                    sx={{
                                        minHeight: '32px !important',
                                        margin: '0 !important',
                                        padding: '0px 10px !important',
                                        '&.Mui-expanded': {
                                            margin: '0 !important',
                                            minHeight: '32px !important',
                                            padding: '0px 10px !important',
                                        },
                                        '.MuiAccordionSummary-content': {
                                            margin: '10px 0 !important'
                                        },
                                        '.MuiAccordionDetails-root': {
                                            padding: '8px 12px 16px !important'
                                        },
                                    }}
                                >
                                    <div className={Classes.AccordionHeader}>
                                        <h5>{faq.question}</h5>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className={Classes.accordinBody}
                                    sx={{
                                        padding: '8px 16px 16px 10px !important',
                                    }}
                                >
                                    <h5 className={Classes.accordionText}>{faq.answer}</h5>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>
                </div>

            </section>
        </>
    )
}
